'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentStripeAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M44.3975 20.736L40.3584 21.6234V18.271L44.3975 17.4V20.736ZM52.7975 22.593C51.2205 22.593 50.2067 23.3489 49.6435 23.8748L49.4343 22.8559H45.8941V42.0172L49.9171 41.1462L49.9332 36.4956C50.5125 36.9228 51.3653 37.5309 52.7814 37.5309C55.6619 37.5309 58.2849 35.1645 58.2849 29.9551C58.2688 25.1894 55.6136 22.593 52.7975 22.593ZM51.8318 33.9155C50.8824 33.9155 50.3192 33.5704 49.933 33.1432L49.9169 27.0464C50.3353 26.5698 50.9146 26.2412 51.8318 26.2412C53.2962 26.2412 54.31 27.9174 54.31 30.0701C54.31 32.2722 53.3123 33.9155 51.8318 33.9155ZM70.9654 30.1194C70.9654 25.9125 68.97 22.593 65.1562 22.593C61.3263 22.593 59.0091 25.9125 59.0091 30.0866C59.0091 35.033 61.7447 37.5309 65.6711 37.5309C67.5861 37.5309 69.0344 37.0872 70.1286 36.4627V33.176C69.0344 33.7348 67.7792 34.0799 66.1861 34.0799C64.6252 34.0799 63.2413 33.5211 63.0642 31.582H70.9332C70.9332 31.4914 70.939 31.2857 70.9457 31.0486V31.0485L70.9457 31.0483V31.0482V31.0481L70.9457 31.0479C70.9547 30.726 70.9654 30.3465 70.9654 30.1194ZM63.0159 28.5583C63.0159 26.7013 64.1263 25.9289 65.1401 25.9289C66.1217 25.9289 67.1677 26.7013 67.1677 28.5583H63.0159ZM40.3584 22.8723H44.3975V37.2515H40.3584V22.8723ZM35.7723 22.8723L36.0298 24.0884C36.9792 22.3136 38.862 22.6751 39.3769 22.8723V26.652C38.8781 26.4712 37.2689 26.2412 36.3195 27.5065V37.2515H32.2965V22.8723H35.7723ZM27.9837 19.3063L24.0573 20.1608L24.0412 33.3239C24.0412 35.7561 25.8274 37.5473 28.209 37.5473C29.5286 37.5473 30.4941 37.3008 31.0251 37.005V33.669C30.5102 33.8827 27.9676 34.6386 27.9676 32.2065V26.3726H31.0251V22.8723H27.9676L27.9837 19.3063ZM18.4736 26.159C17.6207 26.159 17.1057 26.4055 17.1057 27.0464C17.1057 27.7461 17.992 28.054 19.0914 28.4359C20.8838 29.0584 23.2429 29.8778 23.2529 32.9131C23.2529 35.8547 20.9517 37.5473 17.6046 37.5473C16.2207 37.5473 14.708 37.2679 13.2115 36.6106V32.6995C14.5632 33.4554 16.269 34.0141 17.6046 34.0141C18.5057 34.0141 19.1494 33.7676 19.1494 33.0117C19.1494 32.2366 18.1887 31.8823 17.0289 31.4546C15.2626 30.8032 13.0345 29.9814 13.0345 27.2436C13.0345 24.3349 15.2069 22.593 18.4736 22.593C19.8092 22.593 21.1287 22.8066 22.4644 23.3489V27.2107C21.2414 26.537 19.6966 26.159 18.4736 26.159Z",
          fill: "#6772E5"
        }
      )
    ]
  }
);
const VpPaymentStripeAsset = forwardRef(PaymentStripeAsset);

export { VpPaymentStripeAsset as default };
